<template>
    <div v-if="show" 
        :style="{
            left: 0,
            top: 0,
            width: '100vw',
            height: '100vh',
        }"
        class='sm-modal-parent'>
        <div  class='inl-100 small-modal'>
            <div v-if="show"
                class="overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none justify-center items-center flex">
                <div class="relative w-auto my-6 mx-auto max-w-sm">
                    <!--content-->
                    <div
                        style="width: 500px;"
                        class="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                        <!--header-->
                        <div class="flex items-start justify-between p-5 border-b border-solid border-blueGray-200 rounded-t">
                            <h3 class="text-3xl font-semibold">Подтвердите удаление</h3>
                            <button
                                class="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                                v-on:click="modalClose">
                                <span
                                    class="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                                    ×
                                </span>
                            </button>
                        </div>
                        <div class="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
                            <button
                                @click="deleteReuqest"
                                :class="[ 
                                    'bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150'
                                ]"
                                type="button">
                                Подветрдить
                            </button>
                            <button
                                @click="modalClose"
                                :class="[ 
                                    'bg-red-500 text-white active:bg-red-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150']"
                                type="button">
                                Закрыть
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    data() {
        return {
        };
    },
    methods: {

    },
    props: {
        deleteReuqest: {},
        modalClose: {},
        show: {},
    }
}
</script>

<style scoped>
    .sm-modal-parent {
        position: fixed;
        width: 100%;
        height: 100%;
        z-index: 999;
        background-color: rgba(0, 0, 0, 0.5);
    }
    .small-modal {
        position: absolute;
        margin: 0;
        z-index: 99999;
    }
</style>